import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { imgUrl, inr, durationLabel } from "@/lib/api";

const hasLabels = (rows) => rows.some((r) => r.label);

export const RateTable = ({ plan, compact = false }) => {
  const rows = plan.rate_table || [];
  const showLabel = hasLabels(rows);
  const th = "font-accent text-[9px] tracking-[0.2em] uppercase text-white/40 px-4 py-3 text-left";
  const td = `px-4 ${compact ? "py-2" : "py-3"} text-sm`;
  return (
    <div className="border border-white/10 overflow-x-auto" data-testid={`rate-table-${plan.id}`}>
      <table className="w-full">
        <thead className="bg-white/[0.03] border-b border-white/10">
          <tr>
            <th className={th}>#</th>
            {showLabel && <th className={th}>Plan</th>}
            <th className={th}>Amount</th>
            <th className={th}>Interest</th>
            <th className={`${th} text-[#D4AF37]`}>Total</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} className="border-b border-white/5 last:border-0 hover:bg-white/[0.02]" data-testid={`rate-row-${plan.id}-${i}`}>
              <td className={`${td} text-white/30`}>{i + 1}</td>
              {showLabel && <td className={`${td} text-white/60`}>{r.label}</td>}
              <td className={`${td} text-white`}>{inr(r.amount)}</td>
              <td className={`${td} text-white/70`}>{inr(r.interest)}</td>
              <td className={`${td} text-[#D4AF37] font-medium`}>{inr(r.total)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const RateChartDialog = ({ plan, children }) => (
  <Dialog>
    <DialogTrigger asChild>{children}</DialogTrigger>
    <DialogContent className="max-w-4xl w-[95vw] max-h-[90vh] overflow-y-auto bg-[#0A0A0A] border-[#D4AF37]/30 text-white p-0 rounded-none" data-testid={`rate-chart-dialog-${plan.id}`}>
      <div className="grid md:grid-cols-5">
        <div className="md:col-span-2 bg-black">
          <img src={imgUrl(plan.image)} alt={plan.title} className="w-full h-full object-contain max-h-[85vh]" data-testid="rate-chart-poster" />
        </div>
        <div className="md:col-span-3 p-8">
          <DialogHeader className="text-left">
            <p className="font-accent text-[10px] tracking-[0.25em] uppercase text-[#D4AF37]">{plan.category} · {durationLabel(plan)}</p>
            <DialogTitle className="font-display text-2xl tracking-tight text-white">{plan.title}</DialogTitle>
            <DialogDescription className="text-white/50 text-sm">{plan.expected_return} · Min {inr(plan.min_investment)}</DialogDescription>
          </DialogHeader>
          <div className="mt-6">
            <RateTable plan={plan} compact />
          </div>
          {plan.features?.length > 0 && (
            <ul className="mt-6 space-y-2">
              {plan.features.map((f) => (
                <li key={f} className="flex gap-3 text-xs text-white/60">
                  <span className="w-1.5 h-1.5 mt-1.5 bg-[#D4AF37] rotate-45 shrink-0" />
                  {f}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
